import "../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, runtimeCss as _runtimeCss, mergeProps as _mergeProps, mergeComponentProps as _mergeComponentProps, px as _px, withVars as _withVars } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("footer-base__autopilot-3m4ehj", {
  backgroundColor: "var(--primary-orange-500)",
  width: "100%",
  "& .be-ix-link-block": {
    display: "flex",
    justifyContent: "end",
    color: "var(--system-white)",
    "& .be-related-link-container": {
      padding: "24px 0",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "column",
      textAlign: "right",
      "@media (min-width: 768px)": {
        padding: "24px 0",
        gap: "6px 24px",
        flexDirection: "row"
      },
      "@media (min-width: 1024px)": {
        padding: "16px 0"
      },
      "& .be-label": {
        fontWeight: "600",
        flexBasis: "auto",
        marginBottom: "4px",
        "@media (min-width: 768px)": {
          gap: "16px",
          marginBottom: 0
        }
      },
      "& .be-list": {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        "@media (min-width: 768px)": {
          gap: "0 16px",
          flexDirection: "row"
        }
      }
    }
  }
});
const _staticStyles2 = _cssRef("footer-base__cursordefault-0x8iwn", {
  cursor: "default"
});
const _staticStyles3 = _cssRef("footer-base__sitefooter-34bdqo", {
  overflow: "hidden",
  position: "relative",
  zIndex: 10,
  backgroundColor: "var(--system-white)",
  borderTopWidth: "1px",
  borderColor: "var(--primary-orange-500)",
  "@media (max-width: 767px)": {
    marginBottom: "60px"
  }
});
const _staticStyles4 = _cssRef("footer-base__widgetsection-3uwnyq", {
  position: "relative",
  paddingTop: "36px",
  paddingBottom: "72px",
  "@media (max-width: 1200px)": {
    paddingBottom: "0"
  }
});
const _staticStyles5 = _cssRef("footer-base__staticdisclaimer-3tonxw", {
  marginBottom: "24px",
  lineHeight: 1.375
});
const _staticStyles6 = _cssRef("footer-base__dynamicdisclaimerswrap-0cgvxl", {
  fontSize: "14px",
  lineHeight: "20px"
});
const _staticStyles7 = _cssRef("footer-base__subfooter-087fyr", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  borderTopWidth: "1px",
  fontSize: "14px",
  lineHeight: "20px",
  borderColor: "var(--system-grey-300)",
  paddingTop: "12px",
  paddingBottom: "12px",
  "@media (max-width: 767px)": {
    flexDirection: "column",
    gap: "12px",
    fontSize: "18px",
    lineHeight: "28px",
    border: "none"
  }
});
const _staticStyles8 = _cssRef("footer-base__subfootercol-0vjb3g", {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  width: "100%",
  flex: "1 1 auto",
  "@media (max-width: 767px)": {
    justifyContent: "space-between"
  }
});
const _staticStyles9 = _cssRef("footer-base__colophon-358fvl", {
  paddingTop: "16px",
  paddingBottom: "16px",
  textAlign: "left",
  width: "auto",
  "@media (max-width: 767px)": {
    width: "100%",
    textAlign: "center",
    paddingTop: "0"
  }
});
const _staticStyles0 = _cssRef("footer-base__navimageouterwrap-2l3zpi", {
  display: "flex",
  right: "0",
  bottom: "0",
  left: "0",
  paddingTop: "8px",
  paddingBottom: "8px"
});
const _staticStyles1 = _cssRef("footer-base__navimageinnerwrap-1votik", {
  justifyContent: "flex-end",
  paddingBottom: "12px",
  marginTop: "12px",
  flexDirection: "row",
  "& >:not([hidden])~:not([hidden])": {
    marginLeft: "32px"
  },
  display: "flex",
  alignItems: "center",
  width: "100%",
  "@media (max-width: 1200px)": {
    marginTop: "32px",
    paddingBottom: "32px",
    justifyContent: "flex-start"
  },
  "@media (max-width: 767px)": {
    paddingBottom: "12px",
    marginTop: "12px",
    gap: "16px",
    flexDirection: "column"
  }
});
const _staticStyles10 = _cssRef("footer-base__navtitle-0k21i6", {
  paddingBottom: "4px",
  marginBottom: "8px",
  maxWidth: "160px",
  width: "100%",
  lineHeight: "28px",
  fontWeight: 500,
  color: "var(--primary-orange-500)",
  borderBottomWidth: "1px",
  borderColor: "var(--primary-orange-500)",
  fontSize: "21px",
  "@media (max-width: 767px)": {
    fontSize: "18px",
    maxWidth: "unset"
  }
});
const _staticStyles11 = _cssRef("footer-base__navcontainer-3g87c1", {
  display: "flex"
});
const _staticStyles12 = _cssRef("footer-base__navlinksitem-1ih767", {
  marginBottom: "12px",
  "& .nav-links": {
    background: "red",
    paddingLeft: "12px"
  }
});
const _staticStyles13 = _cssRef("footer-base__franchiseaddress-0apg46", {
  fontSize: "16px",
  lineHeight: "24px",
  marginTop: "0",
  color: "var(--system-grey-700)"
});
const _staticStyles14 = _cssRef("footer-base__socialmedialinks-3o1ev7", {
  display: "flex",
  alignItems: "center",
  gap: "24px",
  marginLeft: "auto",
  maxWidth: "max-content",
  listStyle: "none",
  padding: 0,
  margin: 0,
  "& >:not([hidden])~:not([hidden])": {
    marginLeft: "32px"
  },
  "@media (max-width: 767px)": {
    justifyContent: "space-between",
    marginLeft: "unset",
    width: "100%",
    maxWidth: "unset"
  }
});
const _staticStyles15 = _cssRef("footer-base__socialmedialink-10ff35", {
  color: "var(--primary-orange-500)",
  "& svg": {
    fill: "var(--primary-orange-500)",
    width: "21px",
    height: "21px"
  },
  "&:hover": {
    opacity: 0.8
  }
});
const _staticStyles16 = _cssRef("footer-base__licensesection-0gyvk7", {
  marginTop: "20px",
  paddingTop: "20px",
  borderTop: "1px solid",
  borderColor: "var(--system-grey-300)"
});
const _staticStyles17 = _cssRef("footer-base__footershell-2rwp8i", {
  display: "flex",
  justifyContent: "center",
  width: "100%"
});
const _staticStyles18 = _cssRef("footer-base__micrositesocialband-13kzaz", {
  backgroundColor: "var(--primary-orange-500)",
  width: "100%"
});
const _staticStyles19 = _cssRef("footer-base__micrositesociallinks-0fcqcf", {
  display: "flex",
  paddingTop: "12px",
  paddingBottom: "12px",
  justifyContent: "center",
  alignItems: "center",
  listStyle: "none",
  margin: 0,
  paddingLeft: 0,
  paddingRight: 0,
  "& >:not([hidden])~:not([hidden])": {
    marginLeft: "32px"
  }
});
const _staticStyles20 = _cssRef("footer-base__micrositesociallinklight-2827zm", {
  color: "var(--system-white)",
  "& svg": {
    fill: "var(--system-white)"
  }
});
const _staticStyles21 = _cssRef("footer-base__div-0ufcss", {
  padding: "0 65px",
  "@media (max-width: 1600px)": {
    padding: "0 32px"
  },
  "@media (max-width: 1440px)": {
    padding: "0 16px"
  }
});
const _staticStyles22 = _cssRef("footer-base__row-1kxbws", {
  rowGap: "24px",
  gridTemplateRows: "var(--static-styles-1a5u5pdf_gridTemplateRows)",
  "@media (max-width: 767px)": {
    gridTemplateRows: "unset"
  }
});
const _staticStyles23 = _cssRef("footer-base__col-2ljs0g", {
  gridRow: "var(--static-styles-0ttfcmi3_gridRow)",
  "@media (max-width: 1200px)": {
    gridRow: "var(--static-styles-02w9w41r_gridRow)"
  },
  "@media (max-width: 767px)": {
    gridRow: "var(--static-styles-0e4yefvs_gridRow)"
  }
});
const _staticStyles24 = _cssRef("footer-base__li-1dylu5", {
  "@media (min-width: 375px)": {
    marginLeft: "12px"
  }
});
const _staticStyles25 = _cssRef("footer-base__li-06elck", {
  "@media (min-width: 375px)": {
    marginLeft: "8px"
  }
});
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import ResponderLogoIcon from '../../images/first-responder-logo.svg';
import Container from '../primitives/grid/container';
import { colors } from '../primitives/colors';
import RichTextEditorStyles from '../utils/rich-text-editor-styles';
import Link from '../primitives/link';
import IconFacebook from '../../images/svg/facebook.svg';
import IconInstagram from '../../images/svg/instagram.svg';
import IconLinkedIn from '../../images/svg/linkedin.svg';
import IconTwitter from '../../images/svg/twitter.svg';
import IconYoutube from '../../images/svg/youtube.svg';
import { SOCIAL_URL_FACEBOOK, SOCIAL_URL_LINKEDIN, SOCIAL_URL_TWITTER, SOCIAL_URL_YOUTUBE } from '../../constants';
import FranchiseLicenses from '../franchise/microsite/licenses';
import Row from '../primitives/grid/row';
import Col from '../primitives/grid/col';
import { breakpoints, rowPadding } from '../primitives/tokens';
import { Flag, FlagSet } from '../../contexts/events/flags';
import { getPhBootstrap } from '../../contexts/events/events-provider';
import DateText from '../primitives/date-text';

// Shared styles that both footer variants use
export const sharedFooterStyles = {
  autoPilot: _staticStyles,
  cursorDefault: _staticStyles2,
  siteFooter: _staticStyles3,
  widgetSection: _staticStyles4,
  staticDisclaimer: _staticStyles5,
  dynamicDisclaimersWrap: _staticStyles6,
  subfooter: _staticStyles7,
  subfooterCol: _staticStyles8,
  colophon: _staticStyles9,
  navImageOuterWrap: _staticStyles0,
  navImageInnerWrap: _staticStyles1,
  navTitle: _staticStyles10,
  navContainer: _staticStyles11,
  navLinks: (doubleWidth: boolean) => _runtimeCss({
    display: 'grid',
    gridTemplateColumns: doubleWidth ? 'repeat(2, minmax(0, 1fr))' : 'repeat(1, minmax(0, 1fr))',
    columnGap: !doubleWidth ? '0' : '24px',
    marginRight: '12px',
    gridAutoFlow: 'column',
    gridTemplateRows: 'repeat(13, min-content)',
    width: '100%',
    [breakpoints.tb]: {
      display: 'flex',
      flexDirection: 'column'
    }
  }),
  navLinksItem: _staticStyles12,
  franchiseAddress: _staticStyles13,
  socialMediaLinks: _staticStyles14,
  socialMediaLink: _staticStyles15,
  licenseSection: _staticStyles16,
  footerShell: _staticStyles17,
  micrositeSocialBand: _staticStyles18,
  micrositeSocialLinks: _staticStyles19,
  micrositeSocialLinkLight: _staticStyles20
};
type Sublink = {
  title?: string;
  url?: string;
  className?: string;
  sublinks?: Sublink[];
};
type FranchiseSocialMedia = NonNullable<FooterBaseProps['franchise']>['socialMedia'];
const hasMicrositeSocialLinks = (socialMedia: FranchiseSocialMedia | null | undefined): socialMedia is NonNullable<FranchiseSocialMedia> => !!(socialMedia?.linkedIn || socialMedia?.twitter || socialMedia?.instagram || socialMedia?.facebook);
export interface FooterBaseProps {
  isMicrosite: boolean;
  links: Array<{
    title?: string | null;
    links?: Array<{
      title?: string | null;
      url?: string | null;
      className?: string | null;
      sublinks?: Array<{
        title?: string | null;
        url?: string | null;
        className?: string | null;
        sublinks?: Array<{
          title?: string | null;
          url?: string | null;
        }>;
      }>;
    }> | null;
  }> | null;
  staticDisclaimerCopy?: string | null;
  dynamicFooterDisclaimers: ReadonlyArray<{
    contentBefore?: string | null;
    content?: string | null;
    pageMatch?: string | null;
  }>;
  currentPath?: string;
  children?: React.ReactNode;
  franchise?: {
    name?: string | null;
    addressHidden?: boolean | null;
    address?: {
      address?: string | null;
      addressExt?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    } | null;
    socialMedia?: {
      linkedIn?: string | null;
      twitter?: string | null;
      instagram?: string | null;
      facebook?: string | null;
    } | null;
  } | null;
}
const FooterBase: React.FC<FooterBaseProps> = ({
  isMicrosite,
  links,
  staticDisclaimerCopy,
  dynamicFooterDisclaimers,
  currentPath,
  children,
  franchise
}) => {
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hasShowTest = params.has('showTest');
    if (!hasShowTest) return;
    document.querySelectorAll<HTMLElement>('.flag-percent-op').forEach(el => {
      el.style.setProperty('display', 'block', 'important');
    });
    const spanEl = document.getElementById('ph-output-tr') as HTMLSpanElement | null;
    const bootstrapData = getPhBootstrap();
    if (spanEl) {
      // eslint-disable-next-line no-underscore-dangle
      spanEl.innerText = `Live PH Data: ${JSON.stringify(bootstrapData?._debug)} ${JSON.stringify(bootstrapData?.featureFlags)}`;
    }
  }, []);
  return <footer {..._mergeProps({
    css: sharedFooterStyles.siteFooter
  })}>
            {!isMicrosite && <div {..._mergeProps({
      css: sharedFooterStyles.footerShell
    })}>
                    <Container {..._mergeComponentProps({
        css: sharedFooterStyles.autoPilot
      })}>
                        <div className="be-ix-link-block" />
                    </Container>
                </div>}
            {isMicrosite && hasMicrositeSocialLinks(franchise?.socialMedia) && <div {..._mergeProps({
      css: sharedFooterStyles.footerShell
    })}>
                    <Container {..._mergeComponentProps({
        css: sharedFooterStyles.micrositeSocialBand
      })}>
                        <ul {..._mergeProps({
          css: sharedFooterStyles.micrositeSocialLinks
        })}>
                            {franchise.socialMedia.linkedIn && <li>
                                    <Link {..._mergeComponentProps({
              css: sharedFooterStyles.micrositeSocialLinkLight,
              to: `https://linkedin.com/${franchise.socialMedia.linkedIn}`,
              target: "_blank",
              "aria-label": `Visit ${franchise?.name || 'SERVPRO'} on LinkedIn`
            })}>
                                        <IconLinkedIn aria-hidden="true" />
                                    </Link>
                                </li>}
                            {franchise.socialMedia.twitter && <li>
                                    <Link {..._mergeComponentProps({
              css: sharedFooterStyles.micrositeSocialLinkLight,
              to: `https://twitter.com/${franchise.socialMedia.twitter}`,
              target: "_blank",
              "aria-label": `Visit ${franchise?.name || 'SERVPRO'} on Twitter`
            })}>
                                        <IconTwitter aria-hidden="true" />
                                    </Link>
                                </li>}
                            {franchise.socialMedia.instagram && <li>
                                    <Link {..._mergeComponentProps({
              css: sharedFooterStyles.micrositeSocialLinkLight,
              to: `https://instagram.com/${franchise.socialMedia.instagram}`,
              target: "_blank",
              "aria-label": `Visit ${franchise?.name || 'SERVPRO'} on Instagram`
            })}>
                                        <IconInstagram aria-hidden="true" />
                                    </Link>
                                </li>}
                            {franchise.socialMedia.facebook && <li>
                                    <Link {..._mergeComponentProps({
              css: sharedFooterStyles.micrositeSocialLinkLight,
              to: `https://facebook.com/${franchise.socialMedia.facebook}`,
              target: "_blank",
              "aria-label": `Visit ${franchise?.name || 'SERVPRO'} on Facebook`
            })}>
                                        <IconFacebook aria-hidden="true" />
                                    </Link>
                                </li>}
                        </ul>
                    </Container>
                </div>}
            <div {..._mergeProps({
      css: [sharedFooterStyles.footerShell, _staticStyles21]
    })}>
                <Container>
                    <section {..._mergeProps({
          css: sharedFooterStyles.widgetSection,
          id: "main-footer--nav",
          className: isMicrosite ? 'microsite' : ''
        })}>
                        {children}
                        <Row {..._mergeComponentProps({
            css: _withVars(_staticStyles22, {
              "--static-styles-1a5u5pdf_gridTemplateRows": _px(isMicrosite ? 'unset' : 'repeat(2, 1fr)')
            })
          })}>
                            {links?.map((group, id) => {
              if (!group) return null;
              const doubleWidth = !isMicrosite && id === 0;
              const isHalfHeightAtDt = !isMicrosite && id >= links.length - 2;
              const isHalfHeightAtTb = !isMicrosite && id !== 0;
              if (!group.links || group.links.filter(x => !!x).length === 0) return null;
              return <Col {..._mergeComponentProps({
                key: group.title,
                breakpoints: {
                  dt: isMicrosite ? {
                    span: 2
                  } : {
                    span: id === 0 ? 6 : 2
                  },
                  tb: {
                    span: 4
                  }
                },
                css: _withVars(_staticStyles23, {
                  "--static-styles-0ttfcmi3_gridRow": isMicrosite ? undefined : `span ${isHalfHeightAtDt ? 1 : 2}`,
                  "--static-styles-02w9w41r_gridRow": isMicrosite ? undefined : `span ${isHalfHeightAtTb ? 1 : 2}`,
                  "--static-styles-0e4yefvs_gridRow": isMicrosite ? undefined : 'unset'
                })
              })}>
                                        <p {..._mergeProps({
                  css: sharedFooterStyles.navTitle
                })}>{group.title}</p>
                                        <div {..._mergeProps({
                  css: sharedFooterStyles.navContainer
                })}>
                                            <ul {..._mergeProps({
                    css: _runtimeCss(sharedFooterStyles.navLinks(doubleWidth))
                  })}>
                                                {group.links.map(groupLink => {
                      if (!groupLink) return null;
                      const {
                        title,
                        url
                      } = groupLink;
                      const sublinks = ('sublinks' in groupLink && Array.isArray(groupLink.sublinks) ? groupLink?.sublinks : []) as Sublink[];
                      const className = groupLink?.className || '';
                      return <React.Fragment key={title}>
                                                            <li {..._mergeProps({
                          css: sharedFooterStyles.navLinksItem
                        })}>
                                                                {url ? <Link to={url} className={className}>
                                                                        {title}
                                                                    </Link> : <p {..._mergeProps({
                            css: sharedFooterStyles.cursorDefault,
                            className: className
                          })}>
                                                                        {title}
                                                                    </p>}
                                                            </li>
                                                            {sublinks.length > 0 && sublinks.map(sublink => {
                          const {
                            title: sublinkTitle,
                            url: sublinkUrl
                          } = sublink;
                          const nestedSublinks = sublink?.sublinks || [];
                          const subClassName = sublink.className;
                          return <React.Fragment key={sublinkTitle}>
                                                                        <li {..._mergeProps({
                              css: [sharedFooterStyles.navLinksItem, _staticStyles24]
                            })}>
                                                                            {sublinkUrl ? <Link to={sublinkUrl} className={subClassName}>
                                                                                    {sublinkTitle}
                                                                                </Link> : <p {..._mergeProps({
                                css: sharedFooterStyles.cursorDefault,
                                className: subClassName
                              })}>
                                                                                    {sublinkTitle}
                                                                                </p>}
                                                                        </li>
                                                                        {nestedSublinks.length > 0 && nestedSublinks.map(nestedSubLink => {
                              const {
                                title: nestedSublinkTitle,
                                url: nestedSublinkUrl
                              } = nestedSubLink;
                              const nestedClassName = nestedSubLink.className;
                              return <li {..._mergeProps({
                                css: [sharedFooterStyles.navLinksItem, _staticStyles25],
                                key: nestedSublinkTitle
                              })}>
                                                                                        {nestedSublinkUrl ? <Link to={nestedSublinkUrl} className={nestedClassName}>
                                                                                                {nestedSublinkTitle}
                                                                                            </Link> : <p {..._mergeProps({
                                  css: sharedFooterStyles.cursorDefault,
                                  className: nestedClassName
                                })}>
                                                                                                {nestedSublinkTitle}
                                                                                            </p>}
                                                                                    </li>;
                            })}
                                                                    </React.Fragment>;
                        })}
                                                        </React.Fragment>;
                    })}
                                            </ul>
                                        </div>
                                    </Col>;
            })}

                            {/* Franchise licenses as a separate column */}
                            {isMicrosite && franchise && <Col breakpoints={{
              dt: {
                span: 3
              },
              tb: {
                span: 6
              }
            }}>
                                    <FranchiseLicenses />
                                </Col>}

                            {/* Franchise address as the last column in the grid */}
                            {isMicrosite && franchise && franchise.name && !franchise.addressHidden && franchise.address && <Col breakpoints={{
              dt: {
                span: 3
              },
              tb: {
                span: 6
              }
            }}>
                                    <address {..._mergeProps({
                css: sharedFooterStyles.franchiseAddress
              })}>
                                        <strong>{franchise.name}</strong>
                                        <br />
                                        {!!franchise.address?.address && <>
                                                {franchise.address.address}
                                                <br />
                                            </>}
                                        {!!franchise.address?.addressExt && <>
                                                {franchise.address.addressExt}
                                                <br />
                                            </>}
                                        {franchise.address?.city}
                                        {', '}
                                        {franchise.address?.state}
                                        {' '}
                                        {franchise.address?.postalCode}
                                    </address>
                                </Col>}
                        </Row>

                        <div {..._mergeProps({
            css: sharedFooterStyles.navImageOuterWrap
          })}>
                            <div {..._mergeProps({
              css: sharedFooterStyles.navImageInnerWrap
            })}>
                                <StaticImage width={300} loading="lazy" alt="Certificates" formats={['auto', 'webp']} src="../../images/certificates.png" />
                                <ResponderLogoIcon role="img" aria-label="First Responder logo" />
                            </div>
                        </div>
                    </section>

                    {!!staticDisclaimerCopy && <section {..._mergeProps({
          css: sharedFooterStyles.dynamicDisclaimersWrap
        })}>
                            <div {..._mergeProps({
            css: [RichTextEditorStyles, sharedFooterStyles.staticDisclaimer],
            dangerouslySetInnerHTML: {
              __html: staticDisclaimerCopy || ''
            }
          })} />
                        </section>}

                    <section {..._mergeProps({
          css: sharedFooterStyles.dynamicDisclaimersWrap
        })}>
                        {dynamicFooterDisclaimers.filter(fd => fd?.pageMatch === currentPath).map(fd => <React.Fragment key={fd.content}>
                                    {!!fd?.contentBefore && <div {..._mergeProps({
              css: [RichTextEditorStyles, sharedFooterStyles.staticDisclaimer],
              dangerouslySetInnerHTML: {
                __html: fd.contentBefore || ''
              }
            })} />}
                                    {!!fd?.content && <div {..._mergeProps({
              css: [RichTextEditorStyles, sharedFooterStyles.staticDisclaimer],
              dangerouslySetInnerHTML: {
                __html: fd.content || ''
              }
            })} />}
                                </React.Fragment>)}
                    </section>

                    <section {..._mergeProps({
          css: sharedFooterStyles.subfooter,
          id: "main-footer--subfooter"
        })}>
                        <div {..._mergeProps({
            css: sharedFooterStyles.subfooterCol
          })}>
                            <p {..._mergeProps({
              css: sharedFooterStyles.colophon
            })}>
                                ©
                                {' '}
                                <DateText format="year" />
                                {' '}
                                SERVPRO. All rights reserved.
                            </p>
                        </div>
                        {!isMicrosite && <div {..._mergeProps({
            css: sharedFooterStyles.subfooterCol
          })}>
                                <ul {..._mergeProps({
              css: sharedFooterStyles.socialMediaLinks
            })}>
                                    <li>
                                        <Link {..._mergeComponentProps({
                  css: sharedFooterStyles.socialMediaLink,
                  to: SOCIAL_URL_LINKEDIN,
                  target: "_blank",
                  "aria-label": "Visit SERVPRO on LinkedIn"
                })}>
                                            <IconLinkedIn aria-hidden="true" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link {..._mergeComponentProps({
                  css: sharedFooterStyles.socialMediaLink,
                  to: SOCIAL_URL_TWITTER,
                  target: "_blank",
                  "aria-label": "Visit SERVPRO on Twitter"
                })}>
                                            <IconTwitter aria-hidden="true" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link {..._mergeComponentProps({
                  css: sharedFooterStyles.socialMediaLink,
                  to: SOCIAL_URL_YOUTUBE,
                  target: "_blank",
                  "aria-label": "Visit SERVPRO on YouTube"
                })}>
                                            <IconYoutube aria-hidden="true" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link {..._mergeComponentProps({
                  css: sharedFooterStyles.socialMediaLink,
                  to: SOCIAL_URL_FACEBOOK,
                  target: "_blank",
                  "aria-label": "Visit SERVPRO on Facebook"
                })}>
                                            <IconFacebook aria-hidden="true" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>}
                    </section>
                </Container>
            </div>
            <FlagSet flagName="flag-percent-test">
                <Flag variant="control">
                    <span className="flag-percent-op footer-base__span-1obg8s">Variant served: Control</span>
                </Flag>
                <Flag variant="test">
                    <span className="flag-percent-op footer-base__span-1obg8s">Variant served: Test</span>
                </Flag>
            </FlagSet>
            <span id="ph-output-tr" />
        </footer>;
};
export default FooterBase;